<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Kacab Toko</a></li>
                <li class="active">Kacab Toko</li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-right">
                            Sort by &nbsp;
                            <el-select @change='handleFilter' style="width: 200px" class="filter-item" v-model="listQuery.sort">
                              <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select>
                            <el-button type="success" icon="el-icon-plus" @click="addData()">Tambah Data</el-button>
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal" border hover
                          :data="tableData1"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="#"
                            min-width="50">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.no}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column fixed="left"
                            label="Nama"
                            prop="nama"
                            min-width="300">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input class="edit-input" v-model="cari_nama" placeholder="Cari Admin" @keyup.native="cariNama()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.nama }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Bank"
                            prop="bank"
                            min-width="250">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input class="edit-input" v-model="cari_bank" placeholder="Cari Bank" @keyup.native="cariBank()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.bank }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="No Rekening"
                            prop="rekening"
                            min-width="250">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input class="edit-input" v-model="cari_rekening" placeholder="Cari Rekening" @keyup.native="cariRekening()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.rekening }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Pilihan" align="right" header-align="right" width="250">
                            <template slot-scope="scope">
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Ok" placement="top-start">
                                <el-button type="success" size="small" icon="el-icon-check"  @click="confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Edit Kacab" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-edit"  @click="confirmEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Cancel" placement="top-start">
                                <el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <!-- <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Daftar Area" placement="top-start">
                                <el-button type="info" size="small" @click="confirmDet(scope.row)"><i class="material-icons" style="font-size: 10px;">location_city</i></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Tambah Area" placement="top-start">
                                <el-button type="warning" size="small" icon="el-icon-plus" @click="confirmArea(scope.row)"></el-button>
                              </el-tooltip> -->
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Hapus Kacab" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog title="Tambah Kacab" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" width="35%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Bank" prop="bank">
                      <el-input type="text" v-model="row1.bank" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="No Rekening" prop="rekening">
                      <el-input type="text" v-model="row1.rekening" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Kacab" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="35%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Bank" prop="bank">
                      <el-input type="text" v-model="row1.bank" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="No Rekening" prop="rekening">
                      <el-input type="text" v-model="row1.rekening" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="35%">
                  <h4>Apakah Anda yakin akan menghapus admin {{ nama }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormReset" v-loading="loadingModalReset" width="35%">
                  <h4>Apakah Anda yakin akan mereset password admin {{ nama }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormReset = false">Batal</el-button>
                    <el-button type="primary" @click="confirmReset1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Info" :visible.sync="dialogFormInfo" width="35%">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>
                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          tableData1: [],
          tableData2: [],
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_bank: '',
          cari_rekening: '',
          nama: '',
          level: [
            {kode: 'ADMIN TOKO', nama: 'ADMIN TOKO'},
            {kode: 'ADMIN GUDANG', nama: 'ADMIN GUDANG'}
          ],
          coba: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormReset: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          loadingModalReset: false,
          dialogFormInfo: false,
          form: {
            kode: '',
            name: '',
            level: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: '120px',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama kacab', trigger: 'blur' }
            ],
            bank: [
              { required: true, message: 'Silahkan isi bank kacab', trigger: 'blur' }
            ],
            rekening: [
              { required: true, message: 'Silahkan isi rekening kacab', trigger: 'blur' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nama A-Z', key: '+nama' }, { label: 'Nama Z-A', key: '-nama' }],
          total: null,
          page_size: 10,
          current_page: 1
        }
      },
      methods: {
        cariNama () {
          var nama = this.cari_nama
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariBank () {
          var nama = this.cari_bank
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.bank
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariRekening () {
          var nama = this.cari_rekening
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.rekening
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        resetForm (formName) {
          if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields()
          }
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true, bank: '', rekening: ''}
          this.resetForm('formAdd')
          // this.resetForm('formEdit')
        },
        confirmDet: function (row) {
          this.$router.push('/area/' + row.kode + '/' + row.nama)
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          // this.clearForm()
          this.resetForm('formEdit')
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.bank = row.bank
          this.row1.rekening = row.rekening
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.dialogFormVisible = false
              this.dialogFormEdit = false

              var req = ''
              var action = '/'
              if (row.kode !== '') {
                req = {kode: row.kode, nama: row.nama, bank: row.bank, rekening: row.rekening}
                action += 'update'
              } else {
                req = {nama: row.nama, bank: row.bank, rekening: row.rekening}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_kacab + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_kacab + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmReset: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormReset = true
        },
        confirmReset1: function () {
          this.loadingModalReset = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_kacab + '/reset_pass'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormReset = false
              this.loadingModalReset = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormReset = false
            this.loadingModalReset = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = ''
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko_kacab + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data.slice()
              this.total = this.tableData.length
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].no = i + 1
              }
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        this.loadingModal = true
        this.getData()
      }
    }
</script>

<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// TokoKacab1.vue?496893da